import React from 'react';
import ServerAppStage from './serverAppStageCopy';

const Stage = (props) => {
  return (
        <ServerAppStage {...props} />
  );
};

export default Stage;
